import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import { useLocalizedStrings } from "../../localization/LocalizedStringsProvider";
import { fillHeight } from "../../theme";
import UserList from "./UserList";
import RoleList from "./RoleList";

const Menus = () => {
    const location = useLocation();
    const strings = useLocalizedStrings();
    const app = useAppContext();

    return (
        <Box sx={{ ...fillHeight, overflow: "hidden" }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={location.pathname}>
                    <Tab value={`/${app.organizationSlug}/users/users`} label={strings.users} component={Link} to={`/${app.organizationSlug}/users/users`} />
                    <Tab value={`/${app.organizationSlug}/users/roles`} label={strings.roles} component={Link} to={`/${app.organizationSlug}/users/roles`} />
                </Tabs>
            </Box>
            <Box component="main" sx={{ ...fillHeight, overflow: 'hidden', flexGrow: 1, padding: 0 }}>
                {/* Users and roles belong to an organization. With none selected the list fell back to the
                    signed-in user's own org, which for a super admin meant the TouchTab org's users appeared
                    as though they were the customer's. Ask for a selection instead of showing someone else's
                    people. Gating here covers the Roles tab as well, which had the same problem. */}
                {app.organizationId ? (
                    <Routes>
                        <Route path="users" element={<UserList />} />
                        <Route path="roles" element={<RoleList />} />
                    </Routes>
                ) : (
                    <Typography sx={{ p: 2 }} color="text.secondary">{strings.usersSelectOrganization}</Typography>
                )}
            </Box>
        </Box>
    );
};


export default Menus;